@let isLoading = loadingService.isLoading$(this) | async;

<form [formGroup]="form" [waiting]="isLoading">

  <div class="row">
    <div class="col grow">
      <div class="row">
        <div class="grow">
          <icz-form-autocomplete class="grow" label="Křížový odkaz" formControlName="name" [options]="templateOptions"></icz-form-autocomplete>
          <icz-form-autocomplete class="grow" label="Prohledávat pouze některé objekty" formControlName="entityType" [options]="entityTypeOptions$ | async"></icz-form-autocomplete>
        </div>
        <div class="grow"></div>
      </div>

      <div class="col gap-8">
        <icz-button
          label="Vybrat objekty pro propojení odkazem"
          class="select-btn"
          [disabled]="allowableEntityTypes.length === 0"
          (onAction)="openEntitySelector()"
        ></icz-button>

        @if (selectedEntities.length > 0) {
          <div class="row">
            <div class="col gap-4 grow">
              @for (entity of selectedEntities; track entity.id) {
                <icz-form-autocomplete-chip [isMultiline]="true" (removeClicked)="removeEntity(entity)">
                  <div class="row items-center gap-8 p-4">
                    <icz-object-class-icon [objectClass]="entity.objectClass" class="object-icon"></icz-object-class-icon>
                    <span [iczTooltip]="entity.subject">{{ entity.refNumber ?? 'bez čísla jednacího' }} - {{ entity.subject }}</span>
                  </div>
                </icz-form-autocomplete-chip>
              }
            </div>
            <div class="col grow"></div>
          </div>
        }
      </div>
    </div>
  </div>
</form>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="isLoading"
              (onAction)="submit()"
              primary label="Přidat odkaz na objekt"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="isLoading"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
